(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sps-collection"]) return;
  try {
    
  const grid = document.querySelector('[data-sps-col-grid]');
  if (grid) {
    const cards = Array.from(grid.querySelectorAll('.sps-card'));
    const filters = document.querySelectorAll('[data-sps-col-filter]');
    const sorts = document.querySelectorAll('[data-sps-sort]');
    const countEl = document.querySelector('[data-sps-col-count]');
    const activeEl = document.querySelector('[data-sps-active-count]');
    const sheet = document.getElementById('sps-filters');
    const attrFor = { sport: 'data-sps-sport', ground: 'data-sps-ground', stock: 'data-sps-stock' };

    const selected = (key) =>
      Array.from(document.querySelectorAll('[data-sps-col-filter="' + key + '"][aria-pressed="true"]'))
        .map((el) => el.getAttribute('data-value'));

    const recount = () => {
      filters.forEach((button) => {
        const key = button.getAttribute('data-sps-col-filter');
        const val = button.getAttribute('data-value');
        const attr = attrFor[key];
        const n = cards.filter((card) => card.getAttribute(attr) === val).length;
        const count = button.querySelector('.sps-check__count');
        if (count) count.textContent = String(n).padStart(2, '0');
      });
    };

    const apply = () => {
      const sports = selected('sport');
      const grounds = selected('ground');
      const stocks = selected('stock');
      let visible = 0;
      cards.forEach((card) => {
        const sportOk = sports.length === 0 || sports.includes(card.getAttribute('data-sps-sport'));
        const groundOk = grounds.length === 0 || grounds.includes(card.getAttribute('data-sps-ground'));
        const stockOk = stocks.length === 0 || stocks.includes(card.getAttribute('data-sps-stock'));
        const show = sportOk && groundOk && stockOk;
        card.hidden = !show;
        if (show) visible += 1;
      });
      if (countEl) countEl.textContent = visible === 1 ? '1 tee' : visible + ' tees';
      const active = sports.length + grounds.length + stocks.length;
      if (activeEl) activeEl.textContent = String(active);
      const filterDot = document.querySelector('[data-sps-filter-dot]');
      if (filterDot) filterDot.hidden = active === 0;
      const filterBtn = document.querySelector('[data-sps-open-filters]');
      if (filterBtn) filterBtn.hidden = cards.length < 3 && active === 0;
      const sort = document.querySelector('.sps-sort');
      if (sort) sort.hidden = cards.length < 2;
      const applyBtn = document.querySelector('[data-sps-apply]');
      if (applyBtn) applyBtn.textContent = 'Show ' + String(visible).padStart(2, '0') + ' editions';
    };

    filters.forEach((button) => {
      button.addEventListener('click', () => {
        button.setAttribute('aria-pressed', button.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        apply();
      });
    });

    sorts.forEach((button) => {
      button.addEventListener('click', () => {
        sorts.forEach((item) => item.setAttribute('aria-pressed', item === button ? 'true' : 'false'));
        const mode = button.getAttribute('data-sps-sort');
        const ordered = [...cards].sort((a, b) => {
          if (mode === 'low') return (b.getAttribute('data-sps-stock') === 'low' ? 1 : 0) - (a.getAttribute('data-sps-stock') === 'low' ? 1 : 0);
          if (mode === 'date') {
            const da = (a.getAttribute('data-sps-date') || '').split('.').reverse().join('');
            const db = (b.getAttribute('data-sps-date') || '').split('.').reverse().join('');
            return da.localeCompare(db);
          }
          return 0;
        });
        ordered.forEach((card) => grid.appendChild(card));
      });
    });

    document.querySelectorAll('[data-sps-open-filters]').forEach((button) => {
      button.addEventListener('click', () => sheet && sheet.classList.add('is-open'));
    });
    document.querySelectorAll('[data-sps-close-filters]').forEach((button) => {
      button.addEventListener('click', () => sheet && sheet.classList.remove('is-open'));
    });

    recount();
    apply();
  }

  } catch(e) { console.error(e); }
})();
})();
